import React from 'react';

interface EditPencilIconProps {
  size?: number;
  color?: string;
}

/**
 * EditPencilIcon Component
 * @description A pencil/edit icon for editing actions
 */
export const EditPencilIcon: React.FC<EditPencilIconProps> = ({ 
  size = 20, 
  color = '#101018' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 20 20"
    >
      <path 
        fill={color} 
        d="M13.964 2.498 7.742 8.719l.007 3.54 3.532-.007L17.5 6.033v10.632a.833.833 0 0 1-.833.833H3.333a.833.833 0 0 1-.833-.833V3.332a.833.833 0 0 1 .833-.834zm3.107-.75 1.179 1.178-7.66 7.66-1.178.002-.001-1.18z"
      />
    </svg>
  );
};

export default EditPencilIcon;

